import {getLidarFileNames} from "../../getLidarFileNames";


export const losangeles_ca_obj_arr_december_2025 = async (accessToken) =>  {
  try {
    const main_path = 'processed-lidar-data/losangeles_ca_processed/';
    const raw_lidar_paths = await getLidarFileNames(main_path, accessToken)
    const lidar_paths = raw_lidar_paths.data.map(item => item.replace(main_path, '').replace('/', ''));
  return lidar_paths.map((path) => {
    const match = path.match(/\d{8}/);
    let date = '';
if (match) {
  const dateStr = match[0]; // "11082025"

  const month = dateStr.slice(0, 2);
  const day = dateStr.slice(2, 4);
  const year = dateStr.slice(4, 8);

  const readableDate = `${month}/${Number(day)}/${year}`;
  date = readableDate;

}

  
  return {
    url: `${process.env.REACT_APP_LIDAR_CDN_URL}/losangeles_ca_processed/${path}`,
    name: `Los Angeles CA - ${path}`,
    description: `Scan of Los Angeles CA 2025 data`,
    date_uploaded: new Date(date),
    data_identifier: 'losangeles_ca',
    collector: 'NV5',
   projection: "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.4666666666667 +lat_2=34.0333333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs +type=crs",

  }})
  } catch (error) {
    console.error('Error fetching Los Angeles CA lidar paths:', error);
    return [];
  }
 
};

